// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.app-main[data-v-088530dc] {\n  /*50 = navbar  */\n  /* min-height: 100vh; */\n  position: relative;\n  overflow: scroll;\n  /* height: 100%; */\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
